export const QUERY_SEND_SUCCESS = "contact/QUERY_SEND_SUCCESS";
export const QUERY_SEND_FAILURE = "contact/QUERY_SEND_FAILURE";